import { DOCUMENT, Location } from '@angular/common';
import { Component, OnInit, Inject,Input } from '@angular/core';
import {Router, ActivatedRoute, Params, NavigationEnd,ParamMap } from '@angular/router';
import { SearchService } from '../../../services/search.service';
import { HomepageService } from '../../../services/homepage.service';
import { RouterExtService } from '../../../services/previous-route.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../../../services/auth.service';
import { NotifierService } from 'angular-notifier';
import { DatepickerOptions } from 'ng2-datepicker';
import * as $ from 'jquery';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  //private readonly notifier: NotifierService;
  @Input() element;
  preLocId:any='';
  locationFun:string='ngonit';
  librarySetting: any = [];  
  printStyle: string ='';
  sortBy: any;
  exploreId: any;
  constructor(private _location: Location, private authService: AuthService, private homepageService: HomepageService,private activatedRoute: ActivatedRoute, private searchService: SearchService, @Inject(DOCUMENT) private document: Document, private routerService: RouterExtService, private router: Router, private cookieService: CookieService, private notifier: NotifierService ) { 
   this.librarySetting =   this.homepageService.getUpdatedConfig();
   var tnt = this.librarySetting.data.tenantCode.toLowerCase();
    var slctloc = this.cookieService.get('selectedlocation'+tnt);
    //console.log(tnt,'constructor called',slctloc)

    if(this.preLocId == ''){
      this.preLocId= slctloc;
    }
   
    this.homepageService.currentData.subscribe((data:any) => {
      let loc: string = sessionStorage.getItem('lastSearchLocation');
    
      //console.log(loc,this.preLocId,'when loc changed', data,tnt)
      // var newLocId = this.cookieService.get('selectedlocation'+tnt);
      var pagePath = window.location.href;
      //console.log(pagePath, pagePath.indexOf('/searchlist'))
      if (pagePath.indexOf('/searchlist') > -1) {
      
        if ((data != null) && (data != loc)) {
          this.callFun = true;
          this.locationFun='getLocData';
          // console.log('location changes and fun called')
          this.getNewLocData(data);
        }
      }
    });
    
    
  }
  highlightParameter: any = {
    'type':'',
    'in':'',
    'term':''
  };
  filter$: Observable<string>;
  exportOptions:any = [];
  exploreoptions:boolean = false;
  seletedExploreOptions: string = '';
  // librarySetting: any = [];
  resoursesCount: number= 0;
  haveApiError: boolean = false;
  searchType: string;
  searchFor: string;
  searchIn: string;
  exact: string;
  resourceSID: any;
  viewprintstatus: boolean = false;
  readingMin: string;
  readingMax: string;
  pointMin: string;
  pointMax: string;
  Arlevel: string;
  listSize: number = 20;
  pagesCount: any [];

  sortWith: string ;
  descendingWith: boolean = true;
  sortDirections: { [key: string]: true | false } = {
    relevancy: true,
    author: false,
    call: false,
    date: true,
    title: false,
    category: false,
  };
  currentOffset: number =0;
  listView: string = 'true';
  lazyRequeat: boolean;
  viewRefresh = true;
  narrowFilters:  any[] = [];
  facets:  any = [];
  facetsInformation:  any[] ;
  maxRecords:  number = 100;
  infiniteScroll:  boolean = true;
  totalRecords : number;
  resourceId : number;
  exploreSearch: string;
  previousUrl: string;
  resource_id : any;
  responseAPI : boolean = false;

  searchResult: any = [];
  serachDataVisible: boolean = false;
  serachDataVisible1: boolean = false;
  responseAPIstatus: boolean = true;
  exploreParent : string;
  exploreParentid : any;
  callStart : string;
  callEnd : string;
  categoryId : string;

  levelmin : any;
  levelmax : any;
  pointmin : any;
  pointmax : any;

  awardYear: number;
  awardId: number;
  lowYear: any = '';
  highYear: any = '';
  awardName: string = '';

  period:number = 1;  
  psize:number = 50;
  ppublish:any = true;
  copies:any = true;

  limitArray: any = {};
  yearGroups: any[];
  selectedResourcesIds: any = [];
  exportDownloadOptions: any = [];
  exportEmailOptions:any = []; 
  updateMobileToggleInfo: boolean = false;
  isPatronLogin:boolean = false;
  exploreBreadcrum :any = [];
  patronEmail: string = '';
  sendingMail:boolean = false;

  showAddFormStatus :boolean = false;
  showHoldDate :boolean = false;
  lastDayDate:any = '';
  date:any = new Date(Date.now());
  callFun:any = true;

  ngOnInit() {
   
 
    this.homepageService.getConfig().subscribe((data) => {
      if(data.data.settings.resultList.defaultSort!=""){
        this.sortWith= data.data.settings.resultList.defaultSort;
      }else{
        this.sortWith =this.sortWith;
      }
    });

    this.callFun =false;
    this.locationFun='ngonit';
    var dd = new Date(Date.now());
    this.lastDayDate = dd.setDate(dd.getDate()-1); 
    if(this.cookieService.check('userDetail'))
    this.patronEmail = JSON.parse(this.cookieService.get('userDetail')).email; 
    //this.searchResult.resources = [];
    this.previousUrl = this.routerService.getPreviousUrl();
    if(typeof(this.previousUrl) != 'undefined' && this.previousUrl.indexOf('/explore/') >= 0){
      this.exploreParent = "Explore";
      this.exploreBreadcrum =  this.routerService.getExploreBreadcrumb();
      //console.log(this.exploreParent);
    }
    this.routerService.setTextUrl('Search'); 
    this.document.body.classList.add('inner-page');
    this.document.body.classList.add('list');
    const queryParams = this.activatedRoute.snapshot.queryParams;
        const routeParams = this.activatedRoute.snapshot.params;
        this.activatedRoute.queryParams.subscribe(params => {
          this.exploreId = params['exp-btn-id'];
        this.locationFun='ngonit';
        sessionStorage.setItem('lastUrl', this.router.url);

        //console.log(this.routerService.getPreviousUrl())
        this.facets = [];
          this.searchType = params['type'];
          if(typeof(params['title']) != 'undefined'){
            //console.log('I am here');
            this.searchType = 'NoveSearch';
          }

          if(typeof(this.searchType) == 'undefined'){
            //console.log('undefined')
            this.highlightParameter.type = '';
            this.highlightParameter.in = '';
            this.highlightParameter.term = '';
            this.exploreSearch = this.activatedRoute.snapshot.paramMap.get("explore");
            if(typeof(this.exploreSearch) == 'undefined' || this.exploreSearch == null){
              //console.log('Undefined search', '1st step');
              if(typeof(this.activatedRoute.snapshot.paramMap.get("recentlist")) != 'undefined' && this.activatedRoute.snapshot.paramMap.get("recentlist") == 'list'){
                this.searchFor = this.cookieService.get('seachFor');
               //console.log('recent search list', '2nd step');
                this.getRecentList();
              } else 
                if(typeof(this.activatedRoute.snapshot.paramMap.get("my")) == 'string'){
                  if(this.activatedRoute.snapshot.paramMap.get("my") == 'awards'){
                    this.viewRefresh = true;
                    this.awardYear = params['year'];
                    this.awardId = params['award'];
                    this.awardName = params['name'];
                    this.sortWith = 'date';
                    if(typeof(params['low']) != 'undefined'){
                      this.lowYear =  params['low'];
                    }
                    if(typeof(params['high']) != 'undefined'){
                        this.highYear = params['high'];
                    }
                    this.exploreParent = 'Awards & Honors';
                    if(this.awardYear.toString() != ''){
                      this.searchFor = this.awardYear.toString();
                      this.sortWith = 'title';
                    } else if(this.awardName != ''){
                      this.searchFor = this.awardName;
                    } else if(this.lowYear != ''){
                      this.searchFor = this.lowYear+ ' ' +this.highYear;
                    }
                    this.awardsList();
                  } else {
                    var auth =  localStorage.getItem('token');       
                    var token = this.cookieService.check('tempPersonalCollection');
                    if(!token && typeof(auth) != 'string'){
                      var router = this.router;
                      this.responseAPIstatus = false;         
                      this.viewRefresh = false; 
                      this.haveApiError = true;
                      setTimeout(function(){
                        router.navigate(['/']);                  
                      }, 10000);
                    } else if(typeof(auth) != 'string' && token){
                      this.sortWith = 'date';
                      this.mylistTemp();
                    } else {
                      this.mylist();
                    }
                  }
                } else {
                  this.resource_id = this.activatedRoute.snapshot.paramMap.get("resource_id");
                  if(this.resource_id)
                  this.resource_id = this.resource_id.toString().replace(/\D/g, "");
                  this.getResourcesList();
                }
              } else {
                let searchParams = new URLSearchParams(this.exploreSearch);
                if(searchParams.has("exploresearch") === true){
                    this.searchFor = searchParams.get("exploresearch");
                }
                if(searchParams.has("expl") === true){
                    this.exploreParent = searchParams.get("expl");
                }
                if(searchParams.has("explid") === true){
                    this.exploreParentid = searchParams.get("explid");
                }
                this.getExploreSearch();
              }

            } else{

              if(this.searchType == 'detail'){
                this.resourceId = params['resourceid'];
                this.getResourceSearchData();
              } else if(this.searchType == 'series'){
                var alltitles:boolean = false;
                if(params['depth'] == 'title'){
                  alltitles = true;
                }
                var series:number = params['series'];
               this.getSeriesSearchData(params['isbn'],series,alltitles);
                
              } else {
                if(this.searchType == 'PopularTitles'){
                  this.period = params['period'];  
                  this.psize = params['size'];
                  this.ppublish = params['publish'];
                  this.searchFor = 'Popular Titles Search';
                } else if(this.searchType == 'NewInLibrary'){
                  this.period = params['period'];  
                  this.copies = params['copies'];
                  this.ppublish = params['publish'];
                  this.searchFor = 'New In Library Search';
                } else if(this.searchType == 'Basic'){
                  this.highlightParameter.type = this.searchType;
                  this.highlightParameter.term =  decodeURIComponent(params['keyword']);
                  this.highlightParameter.in = params['searchin']; 
                  this.searchFor = decodeURIComponent(params['keyword']);                   
                  this.searchIn = params['searchin'];  
                  this.exact = params['exact'];  
                  this.resourceSID = params['resource'];
                  this.checkLimitTo(params);
                } else if(this.searchType == 'Marc'){
                  this.highlightParameter.type = this.searchType;
                  this.highlightParameter.term = typeof(params['term']) == 'undefined' ? decodeURIComponent(params['keyword']):params['term'];
                  this.highlightParameter.in = 'marc'; 
                  this.searchFor = typeof(params['term']) == 'undefined' ?  decodeURIComponent(params['keyword']) : params['term'];
                  this.searchIn = typeof(params['in']) == 'undefined' ? params['searchin'] : params['in'];
                  this.exact = typeof(params['exact']) == 'undefined' ? 'false' : params['exact'];  
                  this.resourceSID = params['resource'];
                  this.checkLimitTo(params);
                } 
                else if (this.searchType == 'Category' || this.searchType == 'category'){
                  this.highlightParameter.type = this.searchType;
                  this.highlightParameter.term = params['categoryId'];
                  this.categoryId = params['categoryId'];
                  this.searchFor = 'Category';     
                  this.checkLimitTo(params);
                }
                 else if(this.searchType == 'Call' || this.searchType == 'Barcode' ){
                  this.highlightParameter.type = this.searchType;
                  this.highlightParameter.in = 'call/barcode'; 
                  this.checkLimitTo(params);
                  this.searchFor = params['start'];
                  this.highlightParameter.term = params['start'];
                  if($.trim(params['end']) != ''){
                    this.searchFor = params['start']+' to '+params['end'];                   
                    this.highlightParameter.term = params['start']+' '+params['end'];                   
                  }
                  this.callStart = params['start'];
                  this.callEnd = typeof(params['end']) == 'undefined' ? '' : params['end'];
                  this.exact = params['exact'];  
                } else if(this.searchType == 'ReadingCounts'){
                    this.checkLimitTo(params);
                    this.levelmin = params['levelmin'];
                    this.levelmax = params['levelmax'];
                    this.pointmin = params['pointmin'];
                    this.pointmax = params['pointmax'];
                    this.searchFor = "Reading Counts: Levels "+this.levelmin+" - "+this.levelmax+ ", Points "+this.pointmin+"-"+this.pointmax;  
                    this.highlightParameter.type = this.searchType;
                    this.highlightParameter.in = 'RC';
                    this.highlightParameter.term =+this.levelmin+" "+this.levelmax+" "+this.pointmin+" "+this.pointmax;
                    this.exact = params['exact'];  
                }
                else if (this.searchType == 'Fountas') {
                  this.checkLimitTo(params);
                  this.levelmin = params['levelmin'];
                  this.levelmax = params['levelmax'];
                  this.searchFor = "Fountas & Pinnell: Levels " + this.levelmin + " - " + this.levelmax;
                  this.highlightParameter.type = this.searchType;
                  this.highlightParameter.in = 'FP';
                  this.highlightParameter.term = +this.levelmin + " " + this.levelmax;
                  this.exact = params['exact'];
                }
                else if (this.searchType == 'AcceleratedReader') {
                    this.checkLimitTo(params);
                    this.levelmin = params['levelmin'];
                    this.levelmax = params['levelmax'];
                    this.pointmin = params['pointmin'];
                    this.pointmax = params['pointmax'];
                    this.Arlevel = params['int'];  
                    if(this.levelmin == '' && this.levelmax == ''){
                      this.searchFor = "Accelerated Reader: Points "+this.pointmin+" - "+this.pointmax;   
                    }else if(this.pointmin == '' && this.pointmax == ''){
                      this.searchFor = "Accelerated Reader: Levels "+this.levelmin+" - "+this.levelmax;   
                    }else{
                      this.searchFor = "Accelerated Reader: Levels "+this.levelmin+" - "+this.levelmax+ ", Points "+this.pointmin+" - "+this.pointmax;   
                    }
                    this.highlightParameter.type =this.searchType
                    this.highlightParameter.term =+this.levelmin+" "+this.levelmax+" "+this.pointmin+" "+this.pointmax;
                } else if(this.searchType == 'Lexile'){
                    this.checkLimitTo(params);
                    this.levelmin = params['levelmin'];
                    this.levelmax = params['levelmax'];
                    this.pointmin = params['code'];
                    this.pointmax = params['patronType'];
                    this.searchFor = "Lexile: Levels "+this.levelmin+" - "+this.levelmax;
                    this.highlightParameter.in = 'AR';
                    this.highlightParameter.type =this.searchType
                    this.highlightParameter.term =this.levelmin+" "+this.levelmax;
                } else if(this.searchType == 'Boolean'){
                    this.highlightParameter.type =this.searchType
                    this.checkLimitTo(params);
                    this.levelmin = params['parameters'];
                    //console.log(this.levelmin, 'parameter');
                    this.searchFor = "Boolean";
                    this.highlightParameter.term ='';
                }else if(this.searchType == 'NoveSearch'){
                    this.highlightParameter.type = 'NoveList Search';
                    this.checkLimitTo(params);
                    this.levelmin = '&term-1='+params['title']+'&in-1=T&op-1=AND';
                    if(typeof(params['author']) != 'undefined' ){
                      this.levelmin += '&term-2='+params['author']+'&in-2=A&op-2=AND&count=2';
                    }else{
                      this.levelmin += '&count=1';
                    }
                    this.searchFor = "NoveList Search";
                    this.searchType = 'Boolean';
                    this.highlightParameter.in = 'T';
                    this.highlightParameter.term =params['title'];
                }
                //console.log('test1')
               this.getSearchData();
              }
          }
        });

         if( localStorage.getItem('selectedResourcesIds') != null ){
             this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));          
          }
      this.librarySetting =   this.homepageService.getUpdatedConfig();
       if(this.librarySetting.data.settings.resultList.defaultView == 'compact list'){
          this.listView = 'compact';
        }else if(this.librarySetting.data.settings.resultList.defaultView == 'list'){
          this.listView = 'true';
        }else if(this.librarySetting.data.settings.resultList.defaultView == 'grid'){
          this.listView = 'false';
        }
      if(!this.cookieService.check('Popular_title_List_View')){
        this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/');      
        } else {     
          this.listView = this.cookieService.get('Popular_title_List_View');
        } 
        if(this.librarySetting.data.settings.resultList.export.formats.list){
            var temp:object = [];
             temp['key'] = 'list';
             temp['value'] = 'List';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.listWithImage){
            var temp:object = [];
             temp['key'] = 'listwithimage';
             temp['value'] = 'List with Images';
            this.exportOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.listWithImageAndSummary){
            var temp:object = [];
             temp['key'] = 'listWithImageAndSummary';
             temp['value'] = 'List with Images and Summary';
             //this.printStyle = "summary";
            this.exportOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.apa){
            var temp:object = [];
            temp['key'] = 'apa';
            temp['value'] = 'Bibliography - APA';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.mla){
            var temp:object = [];
            temp['key'] = 'mla';
            temp['value'] = 'Bibliography -  MLA';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.chicago){
            var temp:object = [];
            temp['key'] = 'cmos';
            temp['value'] = 'Bibliography - Chicago Style';
            this.exportOptions.push(temp);
            this.exportEmailOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.csv){
            var temp:object = [];
            temp['key'] = 'csv';
            temp['value'] = 'CSV';
            this.exportDownloadOptions.push(temp);
          }
          if(this.librarySetting.data.settings.resultList.export.formats.marc){
            var temp:object = [];
            temp['key'] = 'marc';
            temp['value'] = 'Marc';
            this.exportDownloadOptions.push(temp);
          }
       // this.searchResult.resources = [];
       // if(this.cookieService.check( 'info') ){
        if (localStorage.getItem('info')){
          this.isPatronLogin = true;
        }
    }
    //get data after location changed
    getNewLocData(changedLoc) {
     

      
      // this.routerService.setTextUrl('Search'); 
      // this.document.body.classList.add('inner-page');
      // this.document.body.classList.add('list');
      // const queryParams = this.activatedRoute.snapshot.queryParams;
      //     const routeParams = this.activatedRoute.snapshot.params;
      //     //console.log(queryParams,routeParams,'activated')
        
  
      //   this.activatedRoute.queryParams.subscribe(params => {
      //     //console.log('I am here getNewLocData',params);
      //     let lastKeyword = sessionStorage.getItem('lastSearchKeyword');
      //     //let lastKeyword=this.cookieService.get('seachFor');
      //     //console.log(lastKeyword,params.keyword)
      //     if(this.locationFun === 'ngonit'){
      //        //console.log('return fun not match', this.locationFun);
      //        return true;
      //     }
      //     let sessionUrl = sessionStorage.getItem('lastUrl');
      //     let urlDataArray =[];
      //     let urlParams = sessionUrl.split('?')[1];
      //     let urlParamsArr = urlParams.split('&');
      //     for (let i = 0; i < urlParamsArr.length; i++) {
      //       let urlPair = urlParamsArr[i].split('=');
      //       urlDataArray[urlPair[0]] = urlPair[1]
      //     }
           

      //     for (var key in urlDataArray) {
      //       var value = urlDataArray[key];
      //       //console.log(key, value);
      //       if (params[key] != urlDataArray[key]) {
      //         //console.log('no match');
      //         return true;
      //       }
      //     }
      //   //console.log('out')
      //     // if(lastKeyword != params.keyword){
      //     //   console.log('return', lastKeyword);
      //     //    return true;
      //     // }
      //     //console.log('return false getNewLocData')
      //     this.facets = [];
      //       this.searchType = params['type'];
      //       if(typeof(params['title']) != 'undefined'){
      //         //console.log('I am here');
      //         this.searchType = 'NoveSearch';
      //       }
  
      //       if(typeof(this.searchType) == 'undefined'){
      //         //console.log('undefined getNewLocData')
      //         this.highlightParameter.type = '';
      //         this.highlightParameter.in = '';
      //         this.highlightParameter.term = '';
      //         this.exploreSearch = this.activatedRoute.snapshot.paramMap.get("explore");
      //         if(typeof(this.exploreSearch) == 'undefined' || this.exploreSearch == null){
      //           //console.log('Undefined search', '1st step');
      //           if(typeof(this.activatedRoute.snapshot.paramMap.get("recentlist")) != 'undefined' && this.activatedRoute.snapshot.paramMap.get("recentlist") == 'list'){
      //             this.searchFor = this.cookieService.get('seachFor');
      //            //console.log('recent search list', '2nd step');
      //             this.getRecentList();
      //           } else 
      //             if(typeof(this.activatedRoute.snapshot.paramMap.get("my")) == 'string'){
      //               if(this.activatedRoute.snapshot.paramMap.get("my") == 'awards'){
      //                 this.viewRefresh = true;
      //                 this.awardYear = params['year'];
      //                 this.awardId = params['award'];
      //                 this.awardName = params['name'];
      //                 this.sortWith = 'date';
      //                 if(typeof(params['low']) != 'undefined'){
      //                   this.lowYear =  params['low'];
      //                 }
      //                 if(typeof(params['high']) != 'undefined'){
      //                     this.highYear = params['high'];
      //                 }
      //                 this.exploreParent = 'Awards & Honors';
      //                 if(this.awardYear.toString() != ''){
      //                   this.searchFor = this.awardYear.toString();
      //                   this.sortWith = 'title';
      //                 } else if(this.awardName != ''){
      //                   this.searchFor = this.awardName;
      //                 } else if(this.lowYear != ''){
      //                   this.searchFor = this.lowYear+ ' ' +this.highYear;
      //                 }
      //                 this.awardsList();
      //               } else {
      //                 var auth =  localStorage.getItem('token');       
      //                 var token = this.cookieService.check('tempPersonalCollection');
      //                 if(!token && typeof(auth) != 'string'){
      //                   var router = this.router;
      //                   this.responseAPIstatus = false;         
      //                   this.viewRefresh = false; 
      //                   this.haveApiError = true;
      //                   setTimeout(function(){
      //                     router.navigate(['/']);                  
      //                   }, 10000);
      //                 } else if(typeof(auth) != 'string' && token){
      //                   this.sortWith = 'date';
      //                   this.mylistTemp();
      //                 } else {
      //                   this.mylist();
      //                 }
      //               }
      //             } else {
      //               this.resource_id = this.activatedRoute.snapshot.paramMap.get("resource_id");
      //               if(this.resource_id)
      //               this.resource_id = this.resource_id.toString().replace(/\D/g, "");
      //               this.getResourcesList();
      //             }
      //           } else {
      //             let searchParams = new URLSearchParams(this.exploreSearch);
      //             if(searchParams.has("exploresearch") === true){
      //                 this.searchFor = searchParams.get("exploresearch");
      //             }
      //             if(searchParams.has("expl") === true){
      //                 this.exploreParent = searchParams.get("expl");
      //             }
      //             if(searchParams.has("explid") === true){
      //                 this.exploreParentid = searchParams.get("explid");
      //             }
      //             this.getExploreSearch();
      //           }
  
      //         } else{
  
      //           if(this.searchType == 'detail'){
      //             this.resourceId = params['resourceid'];
      //             this.getResourceSearchData();
      //           } else if(this.searchType == 'series'){
      //             var alltitles:boolean = false;
      //             if(params['depth'] == 'title'){
      //               alltitles = true;
      //             }
      //             var series:number = params['series'];
      //            this.getSeriesSearchData(params['isbn'],series,alltitles);
                  
      //           } else {
      //             if(this.searchType == 'PopularTitles'){
      //               this.period = params['period'];  
      //               this.psize = params['size'];
      //               this.ppublish = params['publish'];
      //               this.searchFor = 'Popular Titles Search';
      //             } else if(this.searchType == 'NewInLibrary'){
      //               this.period = params['period'];  
      //               this.copies = params['copies'];
      //               this.ppublish = params['publish'];
      //               this.searchFor = 'New In Library Search';
      //             } else if(this.searchType == 'Basic'){
      //               this.highlightParameter.type = this.searchType;
      //               this.highlightParameter.term = params['keyword'];
      //               this.highlightParameter.in = params['searchin']; 
      //               this.searchFor = params['keyword'];                   
      //               this.searchIn = params['searchin'];  
      //               this.exact = params['exact'];  
      //               this.resourceSID = params['resource'];
      //               this.checkLimitTo(params);
      //             } else if(this.searchType == 'Marc'){
      //               this.highlightParameter.type = this.searchType;
      //               this.highlightParameter.term = typeof(params['term']) == 'undefined' ? params['keyword']:params['term'];
      //               this.highlightParameter.in = 'marc'; 
      //               this.searchFor = typeof(params['term']) == 'undefined' ? params['keyword'] : params['term'];
      //               this.searchIn = typeof(params['in']) == 'undefined' ? params['searchin'] : params['in'];
      //               this.exact = typeof(params['exact']) == 'undefined' ? 'false' : params['exact'];  
      //               this.resourceSID = params['resource'];
      //               this.checkLimitTo(params);
      //             } 
      //             else if (this.searchType == 'Category' || this.searchType == 'category'){
      //               this.highlightParameter.type = this.searchType;
      //               this.highlightParameter.term = params['categoryId'];
      //               this.categoryId = params['categoryId'];
      //               this.searchFor = 'Category';     
      //               this.checkLimitTo(params);
      //             }
      //              else if(this.searchType == 'Call' || this.searchType == 'Barcode' ){
      //               this.highlightParameter.type = this.searchType;
      //               this.highlightParameter.in = 'call/barcode'; 
      //               this.checkLimitTo(params);
      //               this.searchFor = params['start'];
      //               this.highlightParameter.term = params['start'];
      //               if($.trim(params['end']) != ''){
      //                 this.searchFor = params['start']+' to '+params['end'];                   
      //                 this.highlightParameter.term = params['start']+' '+params['end'];                   
      //               }
      //               this.callStart = params['start'];
      //               this.callEnd = typeof(params['end']) == 'undefined' ? '' : params['end'];
      //               this.exact = params['exact'];  
      //             } else if(this.searchType == 'ReadingCounts'){
      //                 this.checkLimitTo(params);
      //                 this.levelmin = params['levelmin'];
      //                 this.levelmax = params['levelmax'];
      //                 this.pointmin = params['pointmin'];
      //                 this.pointmax = params['pointmax'];
      //                 this.searchFor = "Reading Counts: Levels "+this.levelmin+" - "+this.levelmax+ ", Points "+this.pointmin+"-"+this.pointmax;  
      //                 this.highlightParameter.type = this.searchType;
      //                 this.highlightParameter.in = 'RC';
      //                 this.highlightParameter.term =+this.levelmin+" "+this.levelmax+" "+this.pointmin+" "+this.pointmax;
      //                 this.exact = params['exact'];  
      //             }
      //             else if (this.searchType == 'Fountas') {
      //               this.checkLimitTo(params);
      //               this.levelmin = params['levelmin'];
      //               this.levelmax = params['levelmax'];
      //               this.searchFor = "Fountas & Pinnell: Levels " + this.levelmin + " - " + this.levelmax;
      //               this.highlightParameter.type = this.searchType;
      //               this.highlightParameter.in = 'FP';
      //               this.highlightParameter.term = +this.levelmin + " " + this.levelmax;
      //               this.exact = params['exact'];
      //             }
      //             else if (this.searchType == 'AcceleratedReader') {
      //                 this.checkLimitTo(params);
      //                 this.levelmin = params['levelmin'];
      //                 this.levelmax = params['levelmax'];
      //                 this.pointmin = params['pointmin'];
      //                 this.pointmax = params['pointmax'];
      //                 this.Arlevel = params['int'];  
      //                 this.searchFor = "Accelerated Reader: Levels "+this.levelmin+" - "+this.levelmax+ ", Points "+this.pointmin+" - "+this.pointmax;   
      //                 this.highlightParameter.type =this.searchType
      //                 this.highlightParameter.term =+this.levelmin+" "+this.levelmax+" "+this.pointmin+" "+this.pointmax;
      //             } else if(this.searchType == 'Lexile'){
      //                 this.checkLimitTo(params);
      //                 this.levelmin = params['levelmin'];
      //                 this.levelmax = params['levelmax'];
      //                 this.pointmin = params['code'];
      //                 this.pointmax = params['patronType'];
      //                 this.searchFor = "Lexile: Levels "+this.levelmin+" - "+this.levelmax;
      //                 this.highlightParameter.in = 'AR';
      //                 this.highlightParameter.type =this.searchType
      //                 this.highlightParameter.term =this.levelmin+" "+this.levelmax;
      //             } else if(this.searchType == 'Boolean'){
      //                 this.highlightParameter.type =this.searchType
      //                 this.checkLimitTo(params);
      //                 this.levelmin = params['parameters'];
      //                 //console.log(this.levelmin, 'parameter');
      //                 this.searchFor = "Boolean";
      //                 this.highlightParameter.term ='';
      //             }else if(this.searchType == 'NoveSearch'){
      //                 this.highlightParameter.type = 'NoveList Search';
      //                 this.checkLimitTo(params);
      //                 this.levelmin = '&term-1='+params['title']+'&in-1=T&op-1=AND';
      //                 if(typeof(params['author']) != 'undefined' ){
      //                   this.levelmin += '&term-2='+params['author']+'&in-2=A&op-2=AND&count=2';
      //                 }else{
      //                   this.levelmin += '&count=1';
      //                 }
      //                 this.searchFor = "NoveList Search";
      //                 this.searchType = 'Boolean';
      //                 this.highlightParameter.in = 'T';
      //                 this.highlightParameter.term =params['title'];
      //             }
      //             //console.log('test1')
                  
      //               //console.log('getSearchData called')
                    
      //             this.getSearchData();
      //             //this.callFun = false;  
      //             this.preLocId = changedLoc;

      //             sessionStorage.setItem('lastSearchLocation', changedLoc);
      //           }
      //       }
      //     });
  
      //      if( localStorage.getItem('selectedResourcesIds') != null ){
      //          this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));          
      //       }
      //   this.librarySetting =   this.homepageService.getUpdatedConfig();
      //    if(this.librarySetting.data.settings.resultList.defaultView == 'compact list'){
      //       this.listView = 'compact';
      //     }else if(this.librarySetting.data.settings.resultList.defaultView == 'list'){
      //       this.listView = 'true';
      //     }else if(this.librarySetting.data.settings.resultList.defaultView == 'grid'){
      //       this.listView = 'false';
      //     }
      //   if(!this.cookieService.check('Popular_title_List_View')){
      //     this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/');      
      //     } else {     
      //       this.listView = this.cookieService.get('Popular_title_List_View');
      //     } 
      //     if(this.librarySetting.data.settings.resultList.export.formats.list){
      //         var temp:object = [];
      //          temp['key'] = 'list';
      //          temp['value'] = 'List';
      //         this.exportOptions.push(temp);
      //         this.exportEmailOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.listWithImage){
      //         var temp:object = [];
      //          temp['key'] = 'listwithimage';
      //          temp['value'] = 'List with Images';
      //         this.exportOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.apa){
      //         var temp:object = [];
      //         temp['key'] = 'apa';
      //         temp['value'] = 'Bibliography - APA';
      //         this.exportOptions.push(temp);
      //         this.exportEmailOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.mla){
      //         var temp:object = [];
      //         temp['key'] = 'mla';
      //         temp['value'] = 'Bibliography -  MLA';
      //         this.exportOptions.push(temp);
      //         this.exportEmailOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.chicago){
      //         var temp:object = [];
      //         temp['key'] = 'cmos';
      //         temp['value'] = 'Bibliography - Chicago Style';
      //         this.exportOptions.push(temp);
      //         this.exportEmailOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.csv){
      //         var temp:object = [];
      //         temp['key'] = 'csv';
      //         temp['value'] = 'CSV';
      //         this.exportDownloadOptions.push(temp);
      //       }
      //       if(this.librarySetting.data.settings.resultList.export.formats.marc){
      //         var temp:object = [];
      //         temp['key'] = 'marc';
      //         temp['value'] = 'Marc';
      //         this.exportDownloadOptions.push(temp);
      //       }
      //    // this.searchResult.resources = [];
      //     if(this.cookieService.check( 'info') ){
      //       this.isPatronLogin = true;
      //     }
      }
    
    awardsList() {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){   
                  
            this.listSize = data.data.settings.resultList.pageSize;
            return this.homepageService.awardsList(this.awardYear,this.awardId,this.lowYear, this.highYear, this.listSize,this.sortWith ).subscribe((data) => {
              this.searchResult = data;
              /*if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }*/
              //this.searchResult  = this.searchResult.data;
              var yearsGrp = {};
              this.searchResult.resources.forEach((years) => {
                if(typeof(yearsGrp[years.year]) == 'undefined') {
                  yearsGrp[years.year] = [];
                }
                yearsGrp[years.year].push(years.listItemId);
                
              });
             // this.yearGroups = yearsGrp;
              this.updateFacets(this.searchResult.facets);             
              this.homepageService.updateBannerText(this.awardYear+ ' ' +this.awardName);
              this.totalRecords = this.searchResult.totalCount;
              if(this.totalRecords == 0){
                var $this = this;
                setTimeout(function(){
                  $this._location.back();                 
                }, 10000);
              }
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
          },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    }

    mylistTemp() {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){   
                  
            this.listSize = data.data.settings.resultList.pageSize;
            var token = this.cookieService.get('tempPersonalCollection');
            return this.homepageService.myListTemp(token,this.sortWith,true,20, 0, this.exploreId).subscribe((data) => {
              this.searchResult = data; 

              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.searchResult  = this.searchResult.data;
              if(this.searchResult){
                this.updateFacets(this.searchResult.facets);
                this.searchFor = this.searchResult.caption;
              }
              
              //this.homepageService.updateBannerText(this.searchResult.caption);
              $('#myCollectionLi').find('span.count').text(this.searchResult.totalCount);
              this.exploreParent = 'Resource Lists';
              this.totalRecords = this.searchResult.totalCount;
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
          },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    } 

    mylist() {
      var auth =  localStorage.getItem('token');       
      if(typeof(auth) != 'string'){
        this.responseAPIstatus = false;         
        this.viewRefresh = false; 
        this.haveApiError = true;
        var router = this.router;
        setTimeout(function(){
          router.navigate(['/']);                  
        }, 10000);
        return false;
      }     
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){   
                  
            this.listSize = data.data.settings.resultList.pageSize;
            return this.homepageService.myList(auth,'date',true,this.listSize, 0, this.exploreId).subscribe((data) => {
              this.searchResult = data;            

              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.searchResult  = this.searchResult.data;
              if(this.searchResult.facets){
              this.updateFacets(this.searchResult.facets);
              }
              this.searchFor = this.searchResult.caption;
              
              this.homepageService.updateBannerText(this.searchResult.caption);
              $('#myCollectionLi').find('span.count').text(this.searchResult.totalCount);
              this.exploreParent = 'Resource Lists';
              this.totalRecords = this.searchResult.totalCount;
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
          },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    } 

    getResourcesList() {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){            
            this.listSize = data.data.settings.resultList.pageSize;
            this.sortWith = data.data.settings.resultList.defaultSort;
            //console.log(this.sortWith);
            return this.searchService.getResourceList(this.resource_id, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
              this.searchResult = data; 
              this.descendingWith = this.searchResult.data.descending;
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.searchResult  = this.searchResult.data;
              this.updateFacets(this.searchResult.facets);
              this.searchFor = this.searchResult.caption;
              
              this.homepageService.updateBannerText(this.searchResult.caption);

              this.exploreParent = 'Resource Lists';
              this.totalRecords = this.searchResult.totalCount;
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
          },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    }  	 
    getResourceSearchData() {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            return this.searchService.getResourceSearchData(this.resourceId,this.listSize).subscribe((data) => {
              this.searchResult = data; 
              //this.descendingWith = data.descending;
              this.updateFacets(this.searchResult.facets);
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = this.searchResult.totalCount;
              this.homepageService.updateBannerText(this.searchResult.caption);
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    }

    getSeriesSearchData(isbn,series,alltitles) {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            return this.searchService.getSeriesSearchData(isbn,series,alltitles,this.listSize).subscribe((data) => {
              this.searchResult = data; 
              //this.descendingWith = data.descending;
              this.updateFacets(this.searchResult.facets);
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = this.searchResult.totalCount;
              this.homepageService.updateBannerText(this.searchResult.caption);
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });

     
    }

    getExploreSearch() {
      return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          } 
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            return this.searchService.getExploreSearchData(this.exploreSearch,this.listSize).subscribe((data) => {
              this.searchResult = data; 
              //console.log("Explore search ++++++++++++++", this.descendingWith);
              //this.descendingWith = data.descending;
              this.updateFacets(this.searchResult.facets);
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = this.searchResult.totalCount;
              if(this.totalRecords == 0){
                var $this = this;
                setTimeout(function(){
                  $this._location.back();                 
                }, 10000);
              }
              this.homepageService.updateBannerText(this.searchFor);
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var $this = this;
                setTimeout(function(){
                  $this._location.back();
                  //router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });     
    }



   getRecentList() {
    
      this.responseAPI = true;
      this.viewRefresh = true;
       return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            var RecentURL =  this.cookieService.get( 'recentSearch'); 
         return this.searchService.getRecentSearch(RecentURL).subscribe((data) => {
              this.searchResult = data;
              if(typeof(this.searchResult.data) != 'undefined') {
                this.searchResult = this.searchResult.data;
              } else {
                this.searchResult = data;
              }
              this.updateFacets(this.searchResult.facets);
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = this.searchResult.totalCount;
              this.homepageService.updateBannerText(this.searchFor);
              var pages = (this.searchResult.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
              this.responseAPI = false; 
              this.sortWith = this.searchResult.order;
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
        }
      });
    }


    getSearchData(searchTerm?: string) {
      this.responseAPI = true;
      this.viewRefresh = true;
      //console.log(this.searchFor,'this.searchFor')
      if(this.searchType == 'Basic'){
        return this.homepageService.getConfig().subscribe((data) => {
          // console.log(data,'getconfig')
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
            if(typeof(this.resourceSID) != 'undefined'){
              this.searchIn = '';
              this.searchFor = '';
            } else if(typeof(this.resourceSID) == 'undefined'){
              this.resourceSID = '';
            }
            //console.log(this.limitArray, this.searchFor, this.searchIn, this.resourceSID,this.exact, this.listSize, this.sortWith,'>',this.searchFor)
            // if((this.searchFor != 'undefined') && (this.searchFor != '') && (this.searchFor != null)){
            if(searchTerm){
              this.searchFor =searchTerm;
            }  
         return this.searchService.basicSearch(this.limitArray, this.searchFor, this.searchIn, this.resourceSID,this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
          this.locationFun = 'ngonit';
              this.searchResult = data;
              //console.log(data,'basic search')
              this.descendingWith = data.descending;
              this.updateFacets(this.searchResult.facets);
              if(this.searchResult.totalCount == 1){
                this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = data.totalCount;
              if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
              }else{
                this.homepageService.updateBannerText(this.searchFor);
              }
              //console.log(this.previousUrl, this.routerService.getPreviousUrl());
              var pages = (data.totalCount / this.listSize);
              this.createRange(pages);        
              this.responseAPIstatus = false;         
              this.viewRefresh = false; 
              this.responseAPI = false;
              var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');      
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');  
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/');  
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);

            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          // }
        }
      });

      } else if(this.searchType == 'Marc') {

         return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          this.sortWith = data.data.settings.resultList.defaultSort;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.basicMarc(this.limitArray, this.searchFor, this.searchIn,this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      } else if(this.searchType == 'Call') {

         return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.basicCall(this.limitArray, this.callStart, this.callEnd,this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false;
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/');
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;
                this.viewRefresh = false;
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);
                }, 10000);
              }
            });
          }
        });

      } else if (this.searchType == 'Category' || this.searchType == 'category') {

        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if (data.data.settings.search.filter.availability.enabled === true) {
            this.narrowFilters.push('ava');
          }
          if (data.data.settings.search.filter.category.enabled === true) {
            this.narrowFilters.push('cat');
          }
          if (data.data.settings.search.filter.lexile.enabled === true) {
            this.narrowFilters.push('lxl');
          }
          if (data.data.settings.search.filter.lexileGrade.enabled === true) {
            this.narrowFilters.push('lxg');
          }
          if (data.data.settings.search.filter.lexileCode.enabled === true) {
            this.narrowFilters.push('lxc');
          }
          if (data.data.settings.search.filter.fountas.enabled === true) {
            this.narrowFilters.push('fpl');
          }
          if (data.data.settings.search.filter.rc.enabled === true) {
            this.narrowFilters.push('rcl');
          }
          if (data.data.settings.search.filter.ar.enabled === true) {
            this.narrowFilters.push('arl');
          }
          if (data.data.settings.search.filter.arInterest.enabled === true) {
            this.narrowFilters.push('ari');
          }
          if (data.data.settings.search.filter.year.enabled === true) {
            this.narrowFilters.push('pub');
          }
          if (data.data.settings.search.filter.series.enabled === true) {
            this.narrowFilters.push('ser');
          }
          if (data.data.settings.search.filter.subject.enabled === true) {
            this.narrowFilters.push('sub');
          }
          if (data.status === true && data.data.settings.resultList.pageSize) {
            this.listSize = data.data.settings.resultList.pageSize;
            return this.searchService.basicCategory(this.limitArray, this.categoryId, this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
              this.searchResult = data;
              this.descendingWith = data.descending;
              this.searchFor = data.caption;
              this.updateFacets(this.searchResult.facets);
              if (this.searchResult.totalCount == 1) {
                this.router.navigate(['/resources/detail', this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = data.totalCount;
              if (this.totalRecords == 0) {
                var $this = this;
                setTimeout(function () {
                  $this._location.back();
                }, 10000);
              }
              if (typeof (this.routerService.getPreviousUrl()) != 'undefined') {
                if (this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                else
                  this.homepageService.updateBannerText(this.searchFor);
              } else {
                this.homepageService.updateBannerText(this.searchFor);
              }
              var pages = (data.totalCount / this.listSize);
              this.createRange(pages);
              this.responseAPIstatus = false;
              this.viewRefresh = false;
              this.responseAPI = false;
              var recentList = this.searchService.getLastSearch();
              this.cookieService.set('recentSearch', recentList, 365, '/');
              this.cookieService.set('recentSearchCunt', data.totalCount, 365, '/');
              this.cookieService.set('seachFor', this.searchFor, 365, '/');
              this.cookieService.set('highlightParameter', JSON.stringify(this.highlightParameter), 365, '/');
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            }, (err) => {
              if (err.error.Status !== true) {
                this.responseAPIstatus = false;
                this.viewRefresh = false;
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function () {
                  router.navigate(['/']);
                }, 10000);
              }
            });
          }
        });

      }else if(this.searchType == 'Barcode') {

         return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.basicBarcode(this.limitArray, this.callStart, this.callEnd,this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                //console.log('I am 1265');
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;
                this.viewRefresh = false;
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      } else if(this.searchType == 'ReadingCounts') {

         return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.basicReadingCounts(this.limitArray, this.levelmin, this.levelmax, this.pointmin, this.pointmax, this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                //console.log('I am 1265');
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      } else if(this.searchType == 'AcceleratedReader') {

         return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.acceleratedReader(this.limitArray, this.levelmin, this.levelmax, this.pointmin, this.pointmax, this.Arlevel, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                //console.log('I am 1265');
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      }  else if(this.searchType == 'Lexile') {
        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
            this.listSize = data.data.settings.resultList.pageSize;
           return this.searchService.Lexile(this.limitArray, this.levelmin, this.levelmax, this.pointmin, this.pointmax, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                this.searchResult = data; 
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      } else if(this.searchType == 'Boolean') {
        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
           this.listSize = data.data.settings.resultList.pageSize;
           //console.log(this.limitArray, 'Limit array');
           return this.searchService.booleanSearch(this.limitArray, this.levelmin, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
                //console.log('data of boolean search', data);
                //console.log('data of boolean search for', this.searchFor);
                this.searchResult = data; 
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              this.cookieService.set( 'highlightParameter', JSON.stringify(this.highlightParameter), 365,'/'); 
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var $this = this;
                setTimeout(function(){
                  $this._location.back();
                  //router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      }  else if(this.searchType == 'PopularTitles') {
        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
           this.listSize = data.data.settings.resultList.pageSize;
           var auth = localStorage.getItem('token');
           this.sortWith = 'date';
           return this.searchService.popularandnewSearchSearch(this.period, this.psize, this.ppublish, this.sortWith, auth).subscribe((data) => {
                this.searchResult = data;
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      }  else if(this.searchType == 'NewInLibrary') {
        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if(data.data.settings.search.filter.availability.enabled === true){
            this.narrowFilters.push('ava');
          } 
          if(data.data.settings.search.filter.category.enabled === true){
            this.narrowFilters.push('cat');
          }
          if(data.data.settings.search.filter.lexile.enabled === true){
            this.narrowFilters.push('lxl');
          }
          if(data.data.settings.search.filter.lexileGrade.enabled === true){
            this.narrowFilters.push('lxg');
          }
          if(data.data.settings.search.filter.lexileCode.enabled === true){
            this.narrowFilters.push('lxc');
          }
          if(data.data.settings.search.filter.fountas.enabled === true){
            this.narrowFilters.push('fpl');
          }
          if(data.data.settings.search.filter.rc.enabled === true){
            this.narrowFilters.push('rcl');
          }
          if(data.data.settings.search.filter.ar.enabled === true){
            this.narrowFilters.push('arl');
          }
          if(data.data.settings.search.filter.arInterest.enabled === true){
            this.narrowFilters.push('ari');
          }
          if(data.data.settings.search.filter.year.enabled === true){
            this.narrowFilters.push('pub');
          }
          if(data.data.settings.search.filter.series.enabled === true){
            this.narrowFilters.push('ser');
          }
          if(data.data.settings.search.filter.subject.enabled === true){
            this.narrowFilters.push('sub');
          }
          if(data.status === true && data.data.settings.resultList.pageSize){
           this.listSize = data.data.settings.resultList.pageSize;
           var auth = localStorage.getItem('token');
           this.sortWith = 'date';
           
           return this.searchService.newInLibrarySearchSearch(this.period,this.copies,this.ppublish,this.listSize, this.sortWith, auth).subscribe((data:any) => {
                this.searchResult = data;
                this.descendingWith = data.descending;
                this.updateFacets(this.searchResult.facets);
                if(this.searchResult.totalCount == 1){
                  this.router.navigate(['/resources/detail',this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
                }
                this.totalRecords = data.totalCount;
                if(this.totalRecords == 0){
                  var $this = this;
                  setTimeout(function(){
                    $this._location.back();                 
                  }, 10000);
                }
                if(typeof(this.routerService.getPreviousUrl()) != 'undefined'){
                  if(this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                  else
                  this.homepageService.updateBannerText(this.searchFor);
                }else{
                  this.homepageService.updateBannerText(this.searchFor);
                }
                var pages = (data.totalCount / this.listSize);
                this.createRange(pages);        
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.responseAPI = false;
                var recentList = this.searchService.getLastSearch();
              this.cookieService.set( 'recentSearch', recentList, 365,'/');      
              this.cookieService.set( 'recentSearchCunt', data.totalCount, 365,'/');   
              this.cookieService.set( 'seachFor', this.searchFor, 365,'/');   
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
          }
        });

      }
      if (this.searchType == 'Fountas') {

        return this.homepageService.getConfig().subscribe((data) => {
          this.maxRecords = data.data.settings.resultList.maxItems;
          this.sortWith = data.data.settings.resultList.defaultSort;
          this.infiniteScroll = data.data.settings.resultList.infiniteScroll;
          if (data.data.settings.search.filter.availability.enabled === true) {
            this.narrowFilters.push('ava');
          }
          if (data.data.settings.search.filter.category.enabled === true) {
            this.narrowFilters.push('cat');
          }
          if (data.data.settings.search.filter.lexile.enabled === true) {
            this.narrowFilters.push('lxl');
          }
          if (data.data.settings.search.filter.lexileGrade.enabled === true) {
            this.narrowFilters.push('lxg');
          }
          if (data.data.settings.search.filter.lexileCode.enabled === true) {
            this.narrowFilters.push('lxc');
          }
          if (data.data.settings.search.filter.fountas.enabled === true) {
            this.narrowFilters.push('fpl');
          }
          if (data.data.settings.search.filter.rc.enabled === true) {
            this.narrowFilters.push('rcl');
          }
          if (data.data.settings.search.filter.ar.enabled === true) {
            this.narrowFilters.push('arl');
          }
          if (data.data.settings.search.filter.arInterest.enabled === true) {
            this.narrowFilters.push('ari');
          }
          if (data.data.settings.search.filter.year.enabled === true) {
            this.narrowFilters.push('pub');
          }
          if (data.data.settings.search.filter.series.enabled === true) {
            this.narrowFilters.push('ser');
          }
          if (data.data.settings.search.filter.subject.enabled === true) {
            this.narrowFilters.push('sub');
          }
          if (data.status === true && data.data.settings.resultList.pageSize) {
            this.listSize = data.data.settings.resultList.pageSize;
            return this.searchService.basicFountas(this.limitArray, this.levelmin, this.levelmax, this.exact, this.listSize, this.sortWith, this.exploreId).subscribe((data) => {
              this.searchResult = data;
              this.descendingWith = data.descending;
              //console.log('I am 1265');
              this.updateFacets(this.searchResult.facets);
              if (this.searchResult.totalCount == 1) {
                this.router.navigate(['/resources/detail', this.searchResult.cacheKey, this.searchResult.resources[0].listItemId], { replaceUrl: true });
              }
              this.totalRecords = data.totalCount;
              if (this.totalRecords == 0) {
                var $this = this;
                setTimeout(function () {
                  $this._location.back();
                }, 10000);
              }
              if (typeof (this.routerService.getPreviousUrl()) != 'undefined') {
                if (this.routerService.getPreviousUrl().indexOf('/explore/') >= 0)
                  this.homepageService.updateBannerText(this.cookieService.get('exploreButtonName'));
                else
                  this.homepageService.updateBannerText(this.searchFor);
              } else {
                this.homepageService.updateBannerText(this.searchFor);
              }
              var pages = (data.totalCount / this.listSize);
              this.createRange(pages);
              this.responseAPIstatus = false;
              this.viewRefresh = false;
              this.responseAPI = false;
              var recentList = this.searchService.getLastSearch();
              this.cookieService.set('recentSearch', recentList, 365, '/');
              this.cookieService.set('recentSearchCunt', data.totalCount, 365, '/');
              this.cookieService.set('seachFor', this.searchFor, 365, '/');
              this.cookieService.set('highlightParameter', JSON.stringify(this.highlightParameter), 365, '/');
              $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.totalCount);
            }, (err) => {
              if (err.error.Status !== true) {
                this.responseAPIstatus = false;
                this.viewRefresh = false;
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function () {
                  router.navigate(['/']);
                }, 10000);
              }
            });
          }
        });

      }
  	}
 
    getListSort(sortBy: string, descending: boolean, cache: boolean, offset: number, headers?: boolean) {
      if (!sortBy) {
        sortBy = this.sortWith;
      }
      if (headers) {
        if (this.sortWith === sortBy) {
          this.sortDirections[sortBy] = !this.sortDirections[sortBy];
        } else {
          this.sortDirections[this.sortWith] = this.descendingWith;
        }
        this.descendingWith = this.sortDirections[sortBy] ?? false;
      }
      this.sortWith = sortBy; 
      descending = this.descendingWith;
      this.currentOffset = offset;
      this.viewRefresh = true;
      return this.homepageService.getSortPageByCache(
        sortBy, this.descendingWith, cache, this.listSize, offset, this.facets.join(), this.exploreId
      ).subscribe((data) => {
        this.searchResult = data.data;
        this.updateFacets(this.searchResult.facets);
        this.viewRefresh = false;
        const pages = Math.ceil(data.data.totalCount / this.listSize);
        this.createRange(pages);
        const recentList = this.homepageService.getLastSearch();
        this.cookieService.set('recentSearch', recentList, 365, '/');
        this.cookieService.set('recentSearchCunt', data.data.totalCount.toString(), 365, '/');
        this.cookieService.set('seachFor', this.searchFor, 365, '/');
      }, (err) => {
        if (err.error.Status !== true) {
          this.responseAPIstatus = false;
          this.viewRefresh = false;
          this.haveApiError = true;
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 10000);
        }
      });
    }
    
    lazyLoading(cache, currentOffset, listSize, isPrint = false){
      var offset = (currentOffset + listSize);
      if(this.lazyRequeat == true || this.infiniteScroll === false  || ( this.totalRecords < offset && !isPrint) ){
        return false;
      }
      this.lazyRequeat = true;
      

      if(isPrint){ 
          return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,listSize, currentOffset, this.facets.join(), this.exploreId).subscribe((data) => {
            if(data.data.resources.length > this.searchResult.resources.length){
              data.data.resources.forEach((evt) => {
                this.searchResult.resources.push(evt);
              });
            }
            this.lazyRequeat = false;
            this.viewRefresh = false;
            this.currentOffset = offset;        
            var self = this;
            setTimeout(function(){
              var libraryname = '';
              var tnt = self.librarySetting.data.tenantCode.toLowerCase();
              var slctloc = self.cookieService.get('selectedlocation'+tnt);            
              self.librarySetting.data.settings.location.locations.forEach((loc) =>{
                if(parseInt(loc.id) == parseInt(slctloc) ){
                  libraryname = loc.name;
                }
              });
            
              var html = $('div.list-view').html();
            
              self.printFnWithHtml(html,libraryname,self.searchFor);
              self.viewprintstatus = false;
             },2000);        
            },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
      

      } 
      else if(this.maxRecords > offset ){
        return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,this.listSize, offset, this.facets.join(), this.exploreId).subscribe((data) => {
          data.data.resources.forEach((evt) => {
            this.searchResult.resources.push(evt);
          });
          this.lazyRequeat = false;
          this.viewRefresh = false;
          this.currentOffset = offset;        
          },(err) => {
          if(err.error.Status !== true){
            this.responseAPIstatus = false;         
            this.viewRefresh = false; 
            this.haveApiError = true;
            var router = this.router;
            setTimeout(function(){
              router.navigate(['/']);                  
            }, 10000);
          }
        });
      }
    }

    lazyLoadings(cache, currentOffset, listSize, isPrint = false){
      var offset = (currentOffset + listSize);
      if(this.lazyRequeat == true || this.infiniteScroll === false  || ( this.totalRecords < offset && !isPrint) ){
        return false;
      }
      this.lazyRequeat = true;
      if(isPrint){ 
        return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,listSize, currentOffset, this.facets.join(), this.exploreId).subscribe((data) => {
          if(data.data.resources.length > this.searchResult.resources.length){
            data.data.resources.forEach((evt) => {
              this.searchResult.resources.push(evt);
            });
          }
          this.lazyRequeat = false;
          this.viewRefresh = false;
          this.currentOffset = offset;        
          var self = this;
          setTimeout(function(){
            var libraryname = '';
            var tnt = self.librarySetting.data.tenantCode.toLowerCase();
            var slctloc = self.cookieService.get('selectedlocation'+tnt);            
            self.librarySetting.data.settings.location.locations.forEach((loc) =>{
              if(parseInt(loc.id) == parseInt(slctloc) ){
                libraryname = loc.name;
              }
            });
            
            var html = $('div.list-summary').html();
            
            self.printFnWithHtml(html,libraryname,self.searchFor);
            self.viewprintstatus = false;
          },2000);        
        },(err) => {
          if(err.error.Status !== true){
            this.responseAPIstatus = false;         
            this.viewRefresh = false; 
            this.haveApiError = true;
            var router = this.router;
            setTimeout(function(){
              router.navigate(['/']);                  
            }, 10000);
          }
        });
      } else if(this.maxRecords > offset ){
        return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,this.listSize, offset, this.facets.join(), this.exploreId).subscribe((data) => {
          data.data.resources.forEach((evt) => {
            this.searchResult.resources.push(evt);
          });
          this.lazyRequeat = false;
          this.viewRefresh = false;
          this.currentOffset = offset;        
        },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
             }
        });
      }
    }

    serachDataVisibleFn(event){
      $(event.target).hide();
      $(event.target).parents('ul').find('a').removeClass('hide');
      this.serachDataVisible = true;      
    }
    serachDataVisibleFn1(){
      this.serachDataVisible1 = true;      
    }


    changeView(view){
      this.listView = view;
      this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/' );
      this.viewRefresh = true;
      setTimeout(() => {
      this.viewRefresh = false;
      }, 500); 
    }

      createRange(number){
        var items: any[] = [];
        for(var i = 0; i < number; i++){
           items.push(i);
        }
        this.pagesCount =  items;
      }



    imageError(event, images){
      //console.log(event, 'error', $('body').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
        var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
        if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
        index--;
        this.imageLoad(event, images,index, true);
      } else {
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();          
      }
    }
  
  //Loading best fit image to main resource.  
  imageLoad(event, images,index, fromError = false) {
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      //console.log(tempWidth, event, index);
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();
      }
    },300);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }
  
  narrowSearch(event, cacheKey,facetId) {
    this.currentOffset = 0;
    var index = this.facets.indexOf(facetId);
    if(index > -1){
      this.facets.splice(index, 1);
    } else {
      this.facets.push(facetId);      
    }
    this.viewRefresh = true;
    return this.homepageService.searchNorrowResult(this.sortWith,this.descendingWith,cacheKey,this.listSize, 0,this.facets.join(), this.exploreId).subscribe((data) => {
      this.searchResult = data.data;
      this.updateFacets(this.searchResult.facets);
      this.viewRefresh = false;
      var pages = (data.data.totalCount / this.listSize);
      this.createRange(pages);

      var recentList = this.homepageService.getLastSearch();
      this.cookieService.set( 'recentSearch', recentList, 365,'/');      
      this.cookieService.set( 'recentSearchCunt', data.data.totalCount, 365,'/');   
      this.cookieService.set( 'seachFor', this.searchFor, 365,'/');  
      $('li.SearchResults').removeClass('hide').addClass('show').find('span.count').text(data.data.totalCount);
    },(err) => {
      if(err.error.Status !== true){
        this.responseAPIstatus = false;         
        this.viewRefresh = false; 
        this.haveApiError = true;
        var router = this.router;
        setTimeout(function(){
          router.navigate(['/']);                  
        }, 10000);
      }
    });
  }
  removeNorrow(cacheKey,facetId){
    this.currentOffset = 0;
    var index = this.facets.indexOf(facetId);
    if(index > -1){
      this.facets.splice(index, 1);
    }
    this.viewRefresh = true;
    return this.homepageService.searchNorrowResult(this.sortWith,this.descendingWith,cacheKey,this.listSize, 0,this.facets.join(), this.exploreId).subscribe((data) => {
        this.searchResult = data.data;
        this.updateFacets(this.searchResult.facets);
        this.viewRefresh = false;
        var pages = (data.data.totalCount / this.listSize);
        this.createRange(pages);
      },(err) => {
              if(err.error.Status !== true){
                this.responseAPIstatus = false;         
                this.viewRefresh = false; 
                this.haveApiError = true;
                var router = this.router;
                setTimeout(function(){
                  router.navigate(['/']);                  
                }, 10000);
              }
            });
  }

  updateFacets(facets){
    this.facetsInformation = [];
     facets.forEach((facets) => {
          var facetsData = [];
          if(this.narrowFilters.indexOf(facets.key) > -1 && facets.values[0] ){
            facets.values.forEach((fv) =>  {
              if(parseInt(fv.count) > 0 ){
                facetsData.push(fv);
              }
            });
          }
          if(facetsData[0]){
            var temp = {};
            temp['key'] =  facets.key;  
            temp['caption'] =  facets.caption;  
            temp['selectedId'] =  facets.selectedId;  
            temp['selectedValue'] =  facets.selectedValue;  
            temp['listOrder'] =  facets.listOrder;  
            temp['values'] =  facetsData;
            this.facetsInformation.push(temp);
          }
        });
  }

addToMyList(event, Id){
    var self = this;
    $('.addButton'+Id).addClass('fadeOutUp');    
    $('#myCollectionLi').addClass('fadeOutUpLI');    
      setTimeout(function(){
        $('.addButton'+Id).addClass('hide').removeClass('show').removeClass('fadeOutUp');
        $('.removeButton'+Id).addClass('show').removeClass('hide');        
        this.resoursesCount = $('.addButton'+Id).length;
        var currentList = parseInt($('#myCollectionLi').find('span.count').text());
        self.cookieService.set( 'MyLIstCount' , (currentList + this.resoursesCount) );
        $('#myCollectionLi').find('span.count').text(currentList + this.resoursesCount);
        $('#myCollectionLi').find('a.onViewList').removeClass('hide').addClass('show'); 
        $('#Publish-My-List').removeClass('hide').addClass('show');
        if($('#myCollectionLi').hasClass('hide')){
          $('#myCollectionLi').removeClass('hide');
          $('#myCollectionLi').addClass('show');
        }
        var i:number; 
        for (i = 1;i <= this.resoursesCount;i++) {
          self.selectedResourcesIds.push(Id);          
        }
        localStorage.setItem('selectedResourcesIds', JSON.stringify(self.selectedResourcesIds));    
        //if(self.cookieService.check( 'info')){
        if (localStorage.getItem('info') != null){
          var auth = localStorage.getItem('token');
          self.homepageService.saveMyList(auth,self.selectedResourcesIds).subscribe(data => { },
          (error) => {
                if(self.cookieService.check('tempPersonalCollection')){
                  var cacheKey = self.cookieService.get('tempPersonalCollection');
                } else {
                  var cacheKey = '';              
                }
                var itemIds:any = []; 
                itemIds.push(Id);
                self.homepageService.personalcollection(itemIds, cacheKey).subscribe(data => { 
                  if(data.status){
                    self.cookieService.set( 'tempPersonalCollection', data.data.cacheKey, 365,'/');      
                  }
                });
          });
        } else {
          if(self.cookieService.check('tempPersonalCollection')){
            var cacheKey = self.cookieService.get('tempPersonalCollection');
          } else {
            var cacheKey = '';              
          }
          var itemIds:any = []; 
          itemIds.push(Id);
          self.homepageService.personalcollection(itemIds, cacheKey).subscribe(data => { 
            if(data.status){
              self.cookieService.set( 'tempPersonalCollection', data.data.cacheKey, 365,'/');      
            }
          });
        }        
      }, 1000);   
      setTimeout(function(){
        $('#myCollectionLi').removeClass('fadeOutUpLI');    
      }, 5000);
  }

  removeToMyList(event,Id){
    $(document).find('.addButton'+Id).addClass('show').removeClass('hide');
    $(document).find('.removeButton'+Id).addClass('hide').removeClass('show');
    this.resoursesCount = $('.removeButton'+Id).length;
    var i:number; 
    for (i = 1;i <= this.resoursesCount;i++) {
      var index = this.selectedResourcesIds.indexOf(Id);
      if (index > -1) {
       var index = this.selectedResourcesIds.splice(index, 1);
     }      
    }    
    localStorage.setItem('selectedResourcesIds', JSON.stringify(this.selectedResourcesIds));    
    var currentList = parseInt($('#myCollectionLi').find('span.count').text());
    $('#myCollectionLi').find('span.count').text(currentList - this.resoursesCount);
    var tempCurrentList=currentList - this.resoursesCount;
    this.cookieService.set('MyLIstCount',(tempCurrentList.toString()));
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var auth = localStorage.getItem('token');
      this.homepageService.removeMyList(auth,Id).subscribe(data => { });
    }  else {
      if(this.cookieService.check('tempPersonalCollection')){
        var cacheKey = this.cookieService.get('tempPersonalCollection');
        this.homepageService.removePersonalcollection(Id, cacheKey).subscribe(data => {});
      } 
    } 
  }

  updateMobileToggle(event) {
    if($(event.target).hasClass('open')){
      this.updateMobileToggleInfo = false;      
    } else {
      this.updateMobileToggleInfo = true;      
    }
  }

 showExportOptions(event, type){
    event.preventDefault();
    if(this.seletedExploreOptions != type){
      $('.exploreCon').removeClass('openExploreOption');
    }
      
    if(event.target.nodeName == 'I'){
      var seletor = $(event.target).parent();
    } else {
      var seletor = $(event.target);
    }
    seletor.parent().toggleClass('openExploreOption');
    this.seletedExploreOptions = type;
  }
    
  

  exportList(event,cacheKey,type){
    $('.exploreCon').removeClass('openExploreOption');
    if(type == 'listwithimage'){
      this.listView = 'true';
      this.viewprintstatus = true;
      this.lazyLoading(this.searchResult.cacheKey,this.currentOffset,this.librarySetting.data.settings.resultList.maxItems, true);
     
    }
    else if(type == 'listWithImageAndSummary'){
      this.listView ='summary';
      this.viewprintstatus = true;
      this.lazyLoadings(this.searchResult.cacheKey,this.currentOffset,this.librarySetting.data.settings.resultList.maxItems, true);
     
    }
    else if(type == 'list'){
      this.listView = 'true';
      this.viewprintstatus = true;
      this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,this.searchResult.cacheKey,this.librarySetting.data.settings.resultList.maxItems, 0, this.facets.join(), this.exploreId).subscribe((data) => {
        var html: string = '';           
          data.data.resources.forEach((list) =>{
           html += '<p class="hangingindent" style="float: left;width: 100%;">';
           html += '<span style="font-size:15px;font-weight: 600; float:left;">'+list.title+'</span><br/><span style=" font-size:15px; float:left; width:100%;">'+list.author+'</span><br/><span style="font-size:15px;float:left; width:100%;">'+list.call+'</span>';
           html += '</p>';
          });
          var libraryname = '';
          var tnt = this.librarySetting.data.tenantCode.toLowerCase();
          var slctloc = this.cookieService.get('selectedlocation'+tnt);            
          this.librarySetting.data.settings.location.locations.forEach((loc) =>{
          if(parseInt(loc.id) == parseInt(slctloc) ){
            libraryname = loc.name;
          }
          });
          this.printFn(html,libraryname,this.searchFor);
          this.viewprintstatus = false;
        },(err) => {
          if(err.error.Status !== true){
          this.responseAPIstatus = false;         
          this.viewRefresh = false; 
          this.haveApiError = true;
          var router = this.router;
          setTimeout(function(){
            router.navigate(['/']);                  
          }, 10000);
        }
      });

    } else if(type == 'csv'){
      this.homepageService.getCSV(cacheKey, this.facets).subscribe((data:File) => {
        var device = ['iPhone', 'iPad', 'iPod'];
        const csvName = 'Library Resources.csv';
        const blob = new Blob([data], {type: 'text/csv'});
        if(device.indexOf(window.navigator.platform) > -1 ) {
          if (window.navigator.userAgent.match('CriOS')) { //Chrome iOS
            var reader = new FileReader();
            reader.onloadend = function(e) {
              const reader_result = reader.result;
              if (typeof reader_result === 'string') {
                window.open(reader_result);
              }
              else {
                window.open(reader_result.toString());
              }
            }
            reader.readAsDataURL(blob);
          } else { //Safari & Opera iOS
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = csvName;
            a.click();
            setTimeout(function(){
              window.URL.revokeObjectURL(url);
              a.remove();
            },200);
          }
        //} else if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
         // window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else { //Chrome & Firefox
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = csvName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      },
      (error) => {
        this.notifier.notify('error', error.error.title);
        error.error.errors.id.forEach((res)=>{
          this.notifier.notify('error', res);
        });
      });
    } else if(type == 'marc'){
      this.homepageService.getMarc(cacheKey, this.facets).subscribe((data:File) => {
        var device = ['iPhone', 'iPad', 'iPod'];
        const csvName = 'Library Resources.mrc';
        const blob = new Blob([data], {type: 'application/marc'});
        if(device.indexOf(window.navigator.platform) > -1 ) {
          if (window.navigator.userAgent.match('CriOS')) { //Chrome iOS
            var reader = new FileReader();
            reader.onloadend = function(e) {
              const reader_result = reader.result;
              if (typeof reader_result === 'string') {
                window.open(reader_result);
              }
              else {
                window.open(reader_result.toString());
              }
            }
            reader.readAsDataURL(blob);
          } else { //Safari & Opera iOS
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = csvName;
            a.click();
            setTimeout(function(){
              window.URL.revokeObjectURL(url);
              a.remove();
            },200);
          }
       // } else if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
        //  window.navigator.msSaveOrOpenBlob(blob, csvName);
        } else { //Chrome & Firefox
          const a = document.createElement('a');
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = csvName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      },
      (error) => {
        this.notifier.notify('error', error.error.title);
        error.error.errors.id.forEach((res)=>{
          this.notifier.notify('error', res);
        });
      });
    } else {
      this.homepageService.printFormat(cacheKey, this.facets,type).subscribe( (data:any) => {
        var html: string = ''; 
        var libraryname = '';
        var tnt = this.librarySetting.data.tenantCode.toLowerCase();
        var slctloc = this.cookieService.get('selectedlocation'+tnt);            
        this.librarySetting.data.settings.location.locations.forEach((loc) =>{
        if(parseInt(loc.id) == parseInt(slctloc) ){
          libraryname = loc.name;
        }
        });
        data.data.items.forEach((items,key) =>{
          html += '<p class="hangingindent">';
          items.elements.forEach((text) =>{
            var style = "normal";
            if(text.italic){
              var style = "italic";
            }
            html += '<span style="font-style: '+style+'; font-size:15px;">'+text.text+'</span> ';
          });
          html += '</p>';
        });
        this.printFn(html, libraryname, this.searchFor);
      });
    }
  }

  printFnWithHtml(content,libraryName,searchFor){
    //console.log(content, 'checking');
    var mywindow = window.open('', '_blank');

    mywindow.document.write('<html><head><title>Print</title><link href="https://fonts.googleapis.com/css?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i" rel="stylesheet"><style>@font-face {font-family: "Material Icons";font-style: normal;font-weight: 400;src: url(https://fonts.gstatic.com/s/materialicons/v48/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format("woff2");}.material-icons {font-family: "Material Icons";font-weight: normal;font-style: normal;font-size: 24px;line-height: 1;letter-spacing: normal;text-transform: none;display: inline-block;white-space: nowrap;word-wrap: normal;direction: ltr;-moz-font-feature-settings: "liga";-moz-osx-font-smoothing: grayscale;} body{font-family:"Roboto", sans-serif !important;} p {color:#8c8c8c;}.hangingindent {padding-left: 36px ;text-indent: -36px; }.book-box {display:flex;border-bottom: 1px dashed rgba(0, 0, 0, 0.1);padding: 7px 0;width: 100%;position: relative;}.book-image {height: 55px;overflow:hidden;border: 1px solid rgba(0, 0, 0, 0.1);float: left;padding: 4px;width: 45px;}.book-box .book-box-head {color: #26B6EF;float: left;font-size: 16px;font-weight: 600;padding: 0 0px 0 0;}.book-box .book-image .book-box-head { margin: 0px 0 0px;}.book-image a {width: 100%;}.book-box-head {text-decoration: none;color: #1e1e1e !important;margin: 0 0 5px 0;}.book-image img {float: left;height: 100%;-o-object-fit: cover;object-fit: cover;width: 100%;vertical-align: middle;border-style: none;}.book-box-info {width: calc(100% - 50px);float: left;padding-left: 20px;} .book-box .book-box-info .book-box-head { width: calc(100% - 130px);}.book-box h4 {text-transform: uppercase;background: #f6f6f6 none repeat scroll 0 0;float: right;font-size: 12px;font-weight: 600;margin: 5px 0 0;padding: 0px 10px;}.author {float: left;font-size: 14px;padding: 4px 0;margin: 0;width: 100%;}.star-rating {display: none;}.book-box .description {float: left;font-size: 13px;font-weight: 400;margin: 5px 0 10px;width: 100%;line-height: 20px;color: #666;}.avail-detail .material-icons {color: #8c8c8c;font-size: 21px !important;}.book-box-bottom{display: block;}.book-box-bottom-btn{display:none;}.avail-detail p{font-size: 15px;margin-bottom: 0;float: left;width: auto;min-width: 120px;margin-top: 0px;}.Placeholders {height:60px;  width: 100%;    display: flex;  box-shadow: 0px 0px 1px #F2F2F2;  color: #ffffff; overflow:hidden; padding: 0px 0;  text-align: center;  align-items: center;  justify-content: center;}.Placeholders.primary {background-color: #177BBB;}.Placeholders.info {background-color: #03A9F4;}.Placeholders.success {background-color: #8BC34A;}.Placeholders.mint {background-color: #26A69A;}.Placeholders.warning {background-color: #FFB300;}.Placeholders.danger {  background-color: #F44336;}.Placeholders.purple {background-color: #AB47BC;}.Placeholders.pink {background-color: #F06292;}.Placeholders.datk {background-color: #3A444E;}.Placeholders.gray { background-color: #E9EEEF;}.material-icons {font-size: 30px !important;color: #fff;}.description {display: none;}.modal-dialog{display: none;}</style>');
    mywindow.document.write('</head><body>');    
    mywindow.document.write('<h2 style="text-align: center;margin: 0;padding: 3px 0;float: left;width: 100%;}">Search Results</h2>');
    mywindow.document.write('<h4 style="text-align: center;margin-bottom: 30px;">'+searchFor+'</h4>');
    mywindow.document.write('<h4 style="text-align: center;margin-bottom: 20px;">'+libraryName+'</h4>');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    mywindow.onload = function () {
      const images = mywindow.document.images;
      let loaded = 0;
      function triggerPrint() {
        mywindow.focus();
        mywindow.print();
      }
      if (images.length === 0) {
        setTimeout(triggerPrint, 300);
      } else {
        Array.from(images).forEach((img) => {
          if (img.complete) {
            loaded++;
            if (loaded === images.length) setTimeout(triggerPrint, 300);
          } else {
            img.onload = img.onerror = () => {
              loaded++;
              if (loaded === images.length) setTimeout(triggerPrint, 300);
            };
          }
        });
    }
  };
  mywindow.onafterprint = function () {
    mywindow.close();
  };
    return true;
  }

  printFn(content,libraryname = '',searchFor = ''){
    //return false;
    var mywindow = window.open('', '_blank');
    mywindow.document.write('<html  moznomarginboxes mozdisallowselectionprint><head><title>Print</title><style>.hangingindent {padding-left: 36px ;text-indent: -36px; }</style>');
    mywindow.document.write('</head><body>');    
    mywindow.document.write('<h2 style="text-align:center">Popular Titles</h2>');
    mywindow.document.write('<h4 style="text-align:center;margin-bottom: 30px;">'+searchFor+'</h4>');
    mywindow.document.write('<h4 style="text-align:center;margin-bottom: 20px;">'+libraryname+'</h4>');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');
    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }

  typeOf(value) {
    return typeof value;
  }

  checkLimitTo(params){
    this.limitArray = {};
    if(typeof(params['l-inlib']) != 'undefined')
      this.limitArray['l-inlib'] = params['l-inlib'];
    if(typeof(params['l-cat']) != 'undefined')
      this.limitArray['l-cat'] = params['l-cat'];
    if(typeof(params['l-lexmin']) != 'undefined')
      this.limitArray['l-lexmin'] = params['l-lexmin'];
    if(typeof(params['l-lexmax']) != 'undefined')
      this.limitArray['l-lexmax'] = params['l-lexmax'];
    if(typeof(params['l-lexcode']) != 'undefined')
      this.limitArray['l-lexcode'] = params['l-lexcode'];
    if(typeof(params['l-lexpat']) != 'undefined')
      this.limitArray['l-lexpat'] = params['l-lexpat'];
    if(typeof(params['l-armin']) != 'undefined')
      this.limitArray['l-armin'] = params['l-armin'];
    if(typeof(params['l-armax']) != 'undefined')
      this.limitArray['l-armax'] = params['l-armax'];
    if(typeof(params['l-arminpt']) != 'undefined')
      this.limitArray['l-arminpt'] = params['l-arminpt'];
    if(typeof(params['l-armaxpt']) != 'undefined')
      this.limitArray['l-armaxpt'] = params['l-armaxpt'];
    if(typeof(params['l-arint']) != 'undefined')
      this.limitArray['l-arint'] = params['l-arint'];
    if(typeof(params['l-rcmin']) != 'undefined')
      this.limitArray['l-rcmin'] = params['l-rcmin'];
    if(typeof(params['l-rcmax']) != 'undefined')
      this.limitArray['l-rcmax'] = params['l-rcmax'];
    if(typeof(params['l-rcminpt']) != 'undefined')
      this.limitArray['l-rcminpt'] = params['l-rcminpt'];
    if(typeof(params['l-rcmaxpt']) != 'undefined')
      this.limitArray['l-rcmaxpt'] = params['l-rcmaxpt'];
    if(typeof(params['l-fpmin']) != 'undefined')
      this.limitArray['l-fpmin'] = params['l-fpmin'];
    if(typeof(params['l-fpmax']) != 'undefined')
      this.limitArray['l-fpmax'] = params['l-fpmax'];
  }

  openDailog(type){
    $('.exploreCon').removeClass('openExploreOption');
    $('#emailType').val(type.toUpperCase());
  }
  exportListEmail(event,cacheKey){
    this.sendingMail = true;
    //console.log(cacheKey, $('#emailType').val());
    this.homepageService.getEmail(cacheKey, this.facets, $('#emailType').val()).subscribe((data:any) => {
      this.sendingMail = false;
      $('#closeEmailModal').trigger('click');
      if(data.status)
      this.notifier.notify('success', data.message);
      else
      this.notifier.notify('error', data.message);
    },(error) => {
      this.sendingMail = false;
      $('#closeEmailModal').trigger('click');
      this.notifier.notify('error', error.error.title);
      error.error.errors.id.forEach((res)=>{
        this.notifier.notify('error', res);
      });
    });
  }

//Date picker options.
options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    format: 'MM-dd-yyyy',
    formatTitle: 'MMMM yyyy',
    formatDays: 'EEEEEE',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    minDate: this.lastDayDate, // Minimal selectable date
    //barTitleIfEmpty: 'Desired Date',
    inputClass: 'holdDesireDate',
    placeholder: 'Select Date', // HTML input placeholder attribute (default: '')
    //addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
   // fieldId: 'holdDesireDate', // ID to assign to the input field. Defaults to datepicker-<counter>
    //useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  }
  
//Showing add form for hold.
  showAddFormHold(resourceId,event){
    //if(!this.cookieService.check('info')){
    if (!localStorage.getItem('info')  ){
      $('#loginSpanMessage').remove();
        document.getElementById("loginLia").click();
        $('#loginError').after('<span id="loginSpanMessage">Log in to place a hold on this resource.</span>');
        setTimeout(function(){
          $('#loginSpanMessage').remove();
        },10000);
        //this.isPatronLogin=true;
    } 
    if (!localStorage.getItem('token') && localStorage.getItem('info')){
      $('#loginSpanMessage').remove();
        document.getElementById("loginLia").click();
        $('#loginError').after('<span id="loginSpanMessage">Session expired...please re-log in to place a hold on this resource.</span>');
        setTimeout(function(){
          $('#loginSpanMessage').remove();
        },10000);
        //this.isPatronLogin=true;
    } 

  }

  //Hide adding form
  hideAddForm(){
    this.showAddFormStatus = false; 
    this.showHoldDate = false;   
  }

  //Showing hold date.
  showHoldDateFn(event){
    //var checkboxId=event.target.id;
    if( $(event.target).is(':checked')){
      this.showHoldDate = true;
    } else {
      this.showHoldDate = false;
      this.date = new Date(Date.now());
    }
  }

  //Holding request
  holdResource(event, resourceId,i){
    $(event.target).val('Wait...').attr('disabled', 'disabled');
    // var desiredDate = $('#datepicker-'+i).val();
    var desiredDate = null;
    if(this.showHoldDate){
      desiredDate = $('.holdDesireDate').val();
    }
    //console.log(desiredDate);
    var auth = localStorage.getItem('token');
    var sessionId:any = 0;
    if(this.cookieService.check( 'renewSession') ){
      var sessionId:any = this.cookieService.get( 'renewSession');
    }
    this.homepageService.holdResource(sessionId,resourceId,desiredDate, auth).subscribe( (data:any) => {
        if(data.status){
            this.searchResult.resources[i].holdId = data.data.circHoldId;
            this.searchResult.resources[i].canHold = false;
            this.cookieService.set( 'renewSession', data.data.sessionId, 365,'/'); 
            this.notifier.notify( 'success', data.message);
          } else {
              this.notifier.notify( 'error', data.message);
          }
          $(event.target).val('Hold').removeAttr('disabled');
          $('#closeHoldAdd-'+resourceId).click();
          this.showHoldDate = false;
          this.date = new Date(Date.now());
    },(error)=>{
      this.homepageService.holdResource(sessionId, resourceId, desiredDate, auth).subscribe((data: any) => { },
        (error) =>{
              $(event.target).val('Hold').removeAttr('disabled');
              this.notifier.notify('error', 'Something Went Wrong');
      });
    });
  }
  
  
  //Cancel hold request
  cancelHold(event, holdId,resourceId,i){ 
    var token = localStorage.getItem('token');
    this.searchResult.resources[i].holdId = null;
    $('#cancelholdsClose-'+resourceId).trigger('click');
    this.homepageService.cancelHoldAccount(holdId, token).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message+' successfully');
        this.searchResult.resources[i].canHold = true;
      } else {
        this.searchResult.resources[i].holdId = holdId;
        this.searchResult.resources[i].canHold = false;
        this.notifier.notify( 'error', data.message);        
      }
    },(err)=>{
      this.notifier.notify( 'error', 'Something Went Wrong');
    });
  }
}
